import Head from "next/head";
import ExpectedUnexpectednessTablesPage from "../../../../src/tables/s16/ExpectedUnexpectednessTables.tsx";

export default function ExpectedUnexpectednessTablesRoute() {
  return (
    <>
      <Head>
        <title>TFT Set 16 Expected Unexpectedness Tables</title>
      </Head>
      <ExpectedUnexpectednessTablesPage />
    </>
  );
}

export async function getStaticProps() {
  // const tablesResp = await fetch(
  //   `https://ap.tft.tools/static/s16/hacked_egg.json`,
  // );
  // const tables = await tablesResp.json();

  return {
    props: {
      // tables,
    },
    revalidate: 3600,
  };
}
